import React from "react";
import { FaFacebook, FaInstagram } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Opis */}
          <div className="max-w-3xl mx-auto px-4 text-center">
            <p className="mt-4 text-sm leading-relaxed">
              Pasja do doskonałych smaków od 2010 roku. Tworzymy wyjątkowe
              doświadczenia kulinarne, dostosowane do Twoich potrzeb.
            </p>
          </div>
          {/* Social Media */}
          <div className="flex flex-col items-center md:items-end">
            <h3 className="text-lg font-bold mb-4">Śledź nas</h3>
            <div className="flex space-x-6">
              <a
                href="https://www.facebook.com/AnatomiaSmaku"
                target="_blank"
                className="text-orange-500 hover:text-orange-400 transition-colors duration-300"
                aria-label="Facebook"
              >
                <FaFacebook className="h-8 w-8" />
              </a>
              <a
                href="https://www.instagram.com/anatomia.smaku/"
                target="_blank"
                className="text-orange-500 hover:text-orange-400 transition-colors duration-300"
                aria-label="Instagram"
              >
                <FaInstagram className="h-8 w-8" />
              </a>
            </div>
          </div>
        </div>
        {/* Dolna stopka */}
        <div className="mt-12 border-t border-gray-800 pt-8 text-center text-sm">
          <p>© 2026 Anatomia Smaku. Wszelkie prawa zastrzeżone.</p>
        </div>
      </div>
    </footer>
  );
}
